function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Field, Formik } from 'formik';
import React, { useState } from 'react';
import { Button, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, FormFeedback, Spinner, Row, Col } from 'reactstrap';
import * as yup from 'yup';
import notifications from "../../services/notifications";
import security from "../../services/security";
import translator, { t } from "../../services/translator";
import Captcha from "../common/captcha";
export default (function (_ref) {
  var onSuccess = _ref.onSuccess,
      onFailed = _ref.onFailed,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? null : _ref$actions;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      captchaSuccess = _useState4[0],
      setCaptchaSuccess = _useState4[1]; // Send request to api through security service


  var onSubmit = function onSubmit(_ref2) {
    var username = _ref2.username,
        password = _ref2.password;

    if (!captchaSuccess) {
      return;
    }

    setLoading(true);
    security.login(username, password).then(function (_ref3) {
      var data = _ref3.data;

      if (typeof onSuccess === 'function') {
        if (false === onSuccess(data)) {
          setLoading(false);
        }
      }
    }).catch(function (e) {
      if (e.response && e.response.status === 401) {
        notifications.error(t('oops'), t('invalid_credentials'));
      }

      if (typeof onFailed === 'function') {
        onFailed(e);
      }

      setLoading(false);
    });
  };

  return /*#__PURE__*/React.createElement(Formik, {
    onSubmit: onSubmit,
    initialValues: {
      username: '',
      password: ''
    },
    validationSchema: yup.object({
      username: yup.string().required(translator.translate('field_required')),
      password: yup.string().required(translator.translate('field_required'))
    })
  }, function (_ref4) {
    var handleSubmit = _ref4.handleSubmit,
        handleBlur = _ref4.handleBlur,
        errors = _ref4.errors,
        touched = _ref4.touched;
    return /*#__PURE__*/React.createElement(Form, {
      noValidate: true,
      role: "form",
      onSubmit: handleSubmit,
      className: "coreLoginFormContainer"
    }, /*#__PURE__*/React.createElement(FormGroup, {
      className: "mb-3 coreLoginFormGroup"
    }, /*#__PURE__*/React.createElement(InputGroup, {
      className: "input-group-alternative"
    }, /*#__PURE__*/React.createElement(InputGroupAddon, {
      addonType: "prepend"
    }, /*#__PURE__*/React.createElement(InputGroupText, null, /*#__PURE__*/React.createElement("i", {
      className: "ni ni-email-83"
    }))), /*#__PURE__*/React.createElement(Input, {
      tag: Field,
      placeholder: translator.translate('username'),
      name: "username",
      autoComplete: "false",
      onBlur: handleBlur,
      invalid: errors.username && touched.username
    })), touched.username && /*#__PURE__*/React.createElement(FormFeedback, null, errors.username)), /*#__PURE__*/React.createElement(FormGroup, {
      className: "mb-5 coreLoginFormGroup"
    }, /*#__PURE__*/React.createElement(InputGroup, {
      className: "input-group-alternative"
    }, /*#__PURE__*/React.createElement(InputGroupAddon, {
      addonType: "prepend"
    }, /*#__PURE__*/React.createElement(InputGroupText, null, /*#__PURE__*/React.createElement("i", {
      className: "ni ni-lock-circle-open"
    }))), /*#__PURE__*/React.createElement(Input, {
      tag: Field,
      placeholder: translator.translate('password'),
      type: "password",
      name: "password",
      autoComplete: "false",
      onBlur: handleBlur,
      invalid: errors.password && touched.password
    })), touched.password && /*#__PURE__*/React.createElement(FormFeedback, null, errors.password)), /*#__PURE__*/React.createElement(Captcha, {
      onSuccess: function onSuccess() {
        return setCaptchaSuccess(true);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, loading ? /*#__PURE__*/React.createElement(Spinner, {
      size: "md",
      className: "coreLoginFormSpinner"
    }) : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
      outline: true,
      color: "default",
      type: "submit",
      className: "coreLoginButton",
      disabled: !captchaSuccess
    }, t('connexion')), "\xA0", actions))));
  });
});